import { render, staticRenderFns } from "./EditLinkPage.vue?vue&type=template&id=5cc18260&"
import script from "./EditLinkPage.vue?vue&type=script&lang=js&"
export * from "./EditLinkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports